<script setup>
const route = useRoute();
const nuxtApp = useNuxtApp();
const { getPressRelease } = useWpApi();
const { data, error } = await getPressRelease(route.path, nuxtApp);
const { subnavrefs } = await useGlobals(nuxtApp);

if (
  error.value ||
  // data.value.length === 0 ||
  (!isNaN(data.value?.length) && !data.value.length) ||
  data.value?.notFound === true
) {
  throw createError({ statusCode: 404, statusMessage: "Page Not Found" });
}

const { formatDate } = usePublishedDate();

const publishedDate = formatDate(data);

const isPreview = computed(() => !!route.query.preview);

watch(
  () => data.value,
  (newVal) => {
    if (isPreview.value) return;
    nextTick(() => {
      useWpSeo(data, data.value?.acf?.image?.url);
    });
  },
  { immediate: true }
);

useSchemaOrg([
  defineArticle({
    "@id": data.value?.acf?.taxonomy?.name,
    "@type": "Article",
    copyrightHolder: { "@id ": "https://wsa.com#identity " },
    headline: data.value?.title?.rendered,
    datePublished: publishedDate,
    dateModified: data.value?.modified,
    image: data.value?.acf?.image?.url,
    copyrightYear: data.value?.date?.split("-")[0],
  }),
]);

if (data.value?.acf?.image) {
  useHead({
    meta: [
      {
        hid: "og:image",
        property: "og:image",
        content: data.value?.acf?.image.url,
      },
      {
        hid: "og:image-type",
        property: "og:image-type",
        content: data.value?.acf?.image.mime_type,
      },
      {
        hid: "og:image-width",
        property: "og:image-width",
        content: data.value?.acf?.image.width,
      },
      {
        hid: "og:image-height",
        property: "og:image-height",
        content: data.value?.acf?.image.height,
      },
    ],
  });
}

onMounted(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
})
</script>

<template>
  <div class="page-press-release">
    <SubNavigation
      type="media"
      :key="'press-release'"
      :alternateActivePath="
        subnavrefs.article !== '' ? subnavrefs.press : '/media/press-releases/'
      "
      theme="grey"
    />
    <article>
      <PressReleaseHero
        :headline="data?.title?.rendered"
        :location="data.acf.location"
        :published_date="data?.date"
        :image="data.acf.image"
      />

      <div class="press-release__meta">
        <div class="press-release__inner page-margin">
          <div class="press-release__caption">
            <p class="ts-caption-italic">
              {{ data.acf.image.caption }}
            </p>
          </div>

          <div class="press-release__tags">
            <TaxonomyTag :label="'Press release'" />
          </div>
        </div>
      </div>

      <RichText v-if="data.acf.rich_text" :rich_text="data.acf.rich_text" />
    </article>
    <!-- <Code :data="data" :collapsible="true" /> -->
  </div>
</template>

<style lang="postcss" scoped>
.page-press-release {
  padding-top: units(6);

  &__meta {
    position: relative;
  }

  &__inner {
    @media (--md) {
      position: absolute;
      top: 0;
      left: 0;
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      column-gap: units(2);
    }
  }

  &__tags {
    margin-bottom: units(3);

    @media (--md) {
      grid-column: 1/4;
      order: 1;
    }
  }

  &__caption {
    margin-bottom: units(3);
    color: var(--grey-3);

    @media (--md) {
      grid-column: -1/10;
      order: 2;
    }
  }
}
</style>
